"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultInputs = getDefaultInputs;
exports.createInputsReducer = createInputsReducer;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _invariant = _interopRequireDefault(require("invariant"));

var _mountPoint = require("../util/mountPoint");

var _actionTypes = require("../actions/actionTypes");

function getDefaultInputState(config) {
  return {
    value: config.defaultValue,
    pristine: true
  };
}

function getDefaultInputs(inputConfig) {
  return (0, _mapValues2.default)((0, _omit2.default)(inputConfig, _mountPoint.REDUX_MOUNT_POINT), getDefaultInputState);
}

function _matchesReduxMountPoint(inputConfig, action) {
  return (0, _mountPoint.getReduxMountPoint)(inputConfig) === (action.meta && action.meta.reduxMountPoint);
}

function _syncStateWithInputConfig(inputConfig, state) {
  var otherInputs = {};
  var nsync = true;
  (0, _forEach2.default)(inputConfig, function (config, key) {
    if (key !== _mountPoint.REDUX_MOUNT_POINT && typeof state[key] === 'undefined') {
      otherInputs[key] = getDefaultInputState(config);
      nsync = false;
    }
  });
  return nsync ? state : (0, _objectSpread2.default)({}, otherInputs, state);
}

function createInputsReducer(inputConfig) {
  (0, _invariant.default)(inputConfig, '[redux-inputs]: inputConfig must be defined');
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultInputs(inputConfig);
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_matchesReduxMountPoint(inputConfig, action)) {
      switch (action.type) {
        case _actionTypes.SET_INPUT:
          return (0, _objectSpread2.default)({}, state, action.payload);
      }
    }

    return _syncStateWithInputConfig(inputConfig, state);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-inputs/lib/reducers/index.js
// module id = 413
// module chunks = 0